<template>
  <div class="content">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb20 ftb">
      <el-breadcrumb-item>换电订单</el-breadcrumb-item>
      <el-breadcrumb-item>完成进度</el-breadcrumb-item>
      <el-breadcrumb-item>设备快照</el-breadcrumb-item>
    </el-breadcrumb>
    <p class="ft20 mb20">设备编号：{{}}</p>
    <el-form
      :inline="true"
      :model="form"
      class="demo-form-inline"
    >
      <el-form-item label="时间：">
        <el-date-picker
          clearable
          v-model="timeArr"
          value-format="timestamp"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="端口编号：">
        <el-select v-model="form.platformType" placeholder="请选择端口编号" clearable>
          <el-option label="web应用" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="onsearch">查询</el-button>
    </el-form>
    <el-table
      :data="recordList"
      style="width: 100%;margin-bottom: 20px;"
      class="table-custom"
    >
      <el-table-column prop="name" label="设备快照编号"></el-table-column>
      <el-table-column prop="name" label="接收时间"></el-table-column>
      <el-table-column prop="path" label="端口编号"></el-table-column>
      <el-table-column prop="icon" label="端口状态"></el-table-column>
      <el-table-column prop="sort" label="端口电流"></el-table-column>
      <el-table-column prop="sort" label="端口电压"></el-table-column>
      <el-table-column prop="sort" label="端口服务状态"></el-table-column>
      <el-table-column prop="sort" label="柜门状态"></el-table-column>
      <el-table-column prop="sort" label="二维码编号"></el-table-column>
      <el-table-column prop="sort" label="电池电量"></el-table-column>
      <el-table-column prop="sort" label="电池电流"></el-table-column>
      <el-table-column prop="sort" label="健康状态"></el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      form: {},
      timeArr: [],
      recordList: []
    }
  },
  methods: {
    async onsearch() {
      const params = {};
      const res = await send(params);
      console.log(res, '查询返回');
    }
  },
  components: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/returnOrderMgmt.vue